
import { HttpClient, HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import { environment } from '../../../../environments/environment';
import { DxDataGridComponent, DxDataGridModule, DxFormComponent } from 'devextreme-angular';
import { NicaGridService } from './nica-grid.service';

import { Column } from 'devextreme/ui/data_grid';
import { Apiservice } from '../../../services/api.service';
import { DxiTabComponent } from 'devextreme-angular/ui/nested';
import { FormsTemplateGridService } from '../../../services/nica-grid-template.service';
import DataSource from 'devextreme/data/data_source';
import { _Eventi, _cascateLookUp, _colonne, _dataGridConfig } from './nica-grid-interface.service';




/*
//
export class _dxradiogroup{
  items?:any
  layout="horizontal"
}
export class _tab{
  title?:string
  icon?:string
  disabled?:boolean
  colonneDxDataGrid?:_colonne[];
  name:string;
}

export class _relatedField{
  api?:string;//  Puo Assumere i valori currentDs, currentData, apiweb
  dataField?:any[];  // [{fieldDatasource:xxxx,fieldDestination:yyyyy}
  valore?:string;  // se value il valore del campo altrimenti datafield del record corrente
  key?:string; // key di ricerca sul datasource con value espresso nel campo valore
  queryString?:string; // filtro da applicare a apiWeb  https://www.rentrincliud.it/cer/{{value}}
  executeFunc?:string;// funzione in javasript 
  ExecuteRoutine?:string;//funzione in javascript
}
export class _cascateLookUp{
  api?:string;
  dataField?:string;
  filter?:string;
  text?:any;
  hint?:any;
  iconSize?:any
 
}

export class _button{
  name:string;
  icon?:string;
  text?:string;
  type?:string;

  disabled?:boolean;
  focusStateEnabled?:boolean;
    
}
export class _Eventi{
  'event':any;
  'function'?:any;
  'ExecuteRoutine'?:any;
}[]
export class _CheckButton{
  api?:any;
  dataField?:string;
  filter?:string;
}
export class _itemForm{  
  dataField:string;
  itemType?:string;
  colSpan?:string;
  colCount?:string;
  editorType?:string;
  caption?:string;
  templateLabel?:any;
  icon?:string;
  button?:_button;
  disabled?:boolean;
  tabs?:_tab[]; 
}

export class _itemGroup{  
  colSpan?:string;
  colCount?:string;
  caption?:string;
  name?:string;
  type:string;     // group,tabs
  items?: _itemForm[];
}
export class _dxolookup{
  api?:string;
  dataSurce?:any;
  displayExpr?:string;
  valueExpr?:string;
  filter?:string;
  cascating?:_cascateLookUp;
}
export class _colonne{
  currentValue?:any;
  colSpan?:string;
  template?:string;
  dataField?:string;
  defaultValue?:any;
  itemType?:string;
  editorType?:string;
  dataType?:string;
  caption?:string;
  colVisible?:boolean;  
  optionalButton?:_button;
  isForm?:boolean=true;
  isDataGrid?:boolean=true
  icon?:string;
  type?:string;           // valori ammessi: campo
  relatedField?:_relatedField[]; // definisce un o i campi che verranno cambiati quando cambia il valore
  dxolookup?:_dxolookup;  // Definisce lookupdel campo
  dxradiogroup?:_dxradiogroup; // opzioni per radioBox
  editorOptions?:any;
  onFlyEditorOptions?:any[];
  eventi?:_Eventi[];
  tabs?:_tab[];
}



export class _dataGridConfig {
  dataSource?:any;
  Api?:string;
  QueryString?:string;
  key?:string;   
  selectedRowKeys?:any[];
  form?: {    
    itemGroup?:_itemGroup[];
    colCount?:string;
    colSpan?:string;
  };
  colonneDxDataGrid?:_colonne[];
}
*/
var thisGrid


@Component({
  selector: 'app-nica-grid',
  templateUrl: './nica-grid.component.html',
  styleUrls: ['./nica-grid.component.css']
})
export class NicaGridComponent implements OnInit,OnChanges,AfterViewInit  {
  dataGridConfig:_dataGridConfig
  dataGrid:DxDataGridModule=new DxDataGridModule();
  selectedCategory
  currentComponent; // current dxdatagrid component
  dataSourceColonne:any=[]
  cascatingColumn:any=[]
  relatedColumn:any=[];
  columnByField:any=[];
  costantByField:any=[];
  editorOptions:any=[];
  itemOptions:any = [];
  buttonOptions:any=[];
  mythis:any;
  name='NameGriglia'
  filterKey='';
  formData={}
  // component instance for datafield
  componentInstance:any=[]

  labelMode = 'floating';
  labelLocation = 'top';
  readOnly = false;
  showColon = false;

  @ViewChild('gridMaster', { static: false }) gridMaster: DxDataGridComponent;
  @ViewChild('formMaster', { static: false }) formMaster: DxFormComponent;
  
  @ViewChildren('name_items') name_items: QueryList<any>;
  @ViewChildren('tab_items') tab_items: QueryList<DxiTabComponent>;
  @ViewChildren('group_items') group_items: QueryList<any>;
  
  @ViewChild('dataGrid', { static: true }) dataGridElement: ElementRef;
  
  @Input() QueryString: string;           // query all'avvio 
  @Input() masterKey: string = "id";      // colonna da usare come KEY
  @Input() dxo_selection:string='single'  // modalità di selezione none,single,multiple
  @Input() remoteOperations:boolean=false // se true gestiche lato server la paginazione (skip e take)
  @Input() dxoscrolling:string='';        // valori ammessi '' e virtual
  @Input() dxoEditingMode:string='popup'
  @Input() service:string=''
  @Input() api:string=''
  @Input() template:string=''
  @Input() showGridForm:any=null

  

  editorOption: any;
  CurrentRowIndexEdit: any=0; // rowIndex current edit
  recordNewData:any;
  recordData:any; // contiene i valori appena inizio editor
  allParameterInput: SimpleChanges;
  isNewRow: boolean=true;
  alignments= [
    {
      icon: 'alignleft',
      alignment: 'left',
      hint: 'Align left',
      onClick: ($event) => {
        this.vedichenenescefuori($event)
      }
    },
    {
      icon: 'aligncenter',
      alignment: 'center',
      hint: 'Center',
      onClick: () => {
        console.log('Button 2 clicked');
      }
    },
    {
      icon: 'alignright',
      alignment: 'right',
      hint: 'Align right',
      onClick: () => {
        console.log('Button 3 clicked');
      }
    },
    {
      icon: 'alignjustify',
      alignment: 'justify',
      hint: 'Justify',
      onClick: () => {
        console.log('Button 4 clicked');
      }
    },
  ];
  

  updateCell(rowIndex, dataField, value) {
    if(!this.showGridForm)
      this.gridMaster.instance.cellValue(rowIndex, dataField, value);
    else
      this.formMaster.instance.repaint()
    //this.gridMaster.instance.saveEditData();
}
  onValueChanged (e) {
    const previousValue = e.previousValue;
    const newValue = e.value;
    console.log("Cambiato valore  ",e)
}
  constructor(
    public FormsTemplateGridService:FormsTemplateGridService,
    public nicaGridService:NicaGridService,
    private appService: Apiservice,
    public http: HttpClient,) {
      this.mythis = this;
      //this.setStateValue = this.setStateValue.bind(this);
      
      //itemOptions
     }
  SettaOptionGruppo(name,option,value){
    let Groups=this.group_items.toArray(); 
    console.log("I gruppi ",Groups)
    //const index = Groups.findIndex(item => item['element']['nativeElement']['name'] === name);
    const index = Groups.findIndex(item => item['name'] === name);    
    if(index>-1){
      Groups[index][option]=value;
    }
  }
  SettaOptionTabs(nameTabs,option,value){
    let iTabs=this.tab_items.toArray(); 
    const index = iTabs.findIndex(item => item['element']['nativeElement']['name'] === nameTabs);
    //let iTab = iTabs.filter(r => r['element']['nativeElement']['name'] == nameTabs);
    if(index>-1){
      //iTab[option]=value;
      iTabs[index][option]=value;
    }
  }
  createDataGridRunTime() { // da chatgpt ma non funziona
    const dataSource = new DataSource({
      store: new CustomStore({
        loadMode: 'raw', // or 'processed'
        load: (loadOptions) => {
          // Carica i dati dal tuo backend o da qualsiasi altra fonte
          return [
            // Dati della griglia
          ];
        }
      })
    });

    const dataGridOptions = {
      dataSource: dataSource
      // Altre opzioni del DxDataGrid come necessario
    };

    //const dataGridInstance = new DxDataGridModule(this.dataGridElement.nativeElement, dataGridOptions);
    //dataGridInstance.repaint(); // Aggiorna il componente se necessario
  }
  ngAfterViewInit(): void {
    console.log("ecco i tabs ",this.tab_items)
     let iTabs=this.tab_items.toArray(); 
     console.log(iTabs[0]['element'].nativeElement['name'])
         //document.getElementById("headerHtml").textContent=this.dataGridConfig.form.headerHtml;
    $("#headerHtml").html(this.dataGridConfig.form.headerHtml);

     //nativeElement['name']
    //this.tab_items['_results'][0].disabled=true;
    //iTabs[0].disabled=true;
    //throw new Error('Method not implemented.');
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.allParameterInput=changes
    console.log('ngOnChanges - myProp = ' , changes);
    //throw new Error('Method not implemented.');
  }
  callBackScript(value:any){
    alert('callBackScript')
  }
  ngOnInit() {
    this.mythis = this;
    this.OptionalButtonClick = this.OptionalButtonClick.bind(this);
    //this.setDxiColumn = this.setDxiColumn.bind(this);

    /*let servletAnswer = '<script type=\"text/javascript\">function settaThis(value) {thisGrid=value;}</script>';
    $('body').append(servletAnswer);
    servletAnswer = '<script type=\"text/javascript\">function findthisGrid() {return thisGrid;}</script>';
    $('body').append(servletAnswer);
    servletAnswer = '<script type=\"text/javascript\">function MyButtonClik() {alert("ho clikkato");}</script>';
    $('body').append(servletAnswer);
    eval("settaThis(this.mythis)");
    */
    
   
    this.dataGridConfig=this.FormsTemplateGridService.getTemplateService(this.template)
    this.dataGridConfig.QueryString=this.QueryString || ''
    console.log("eccooooooooooooooooooooo ",this.dataGridConfig)


    this.dataGridConfig.dataSource=this.nicaGridService.CreateDs(this.dataGridConfig.Api,this.dataGridConfig.QueryString,this.dataGridConfig.key)
    setTimeout(() => {             
        //this.setFilter("?filter=siglaprovincia eq 'NA'&order=descrizione")
       // this.setFilter("?order=descrizione")
       
    }, 5000); 
    // creazione data source
    let i=-1;
    let _this=this;

    this.dataGridConfig.colonneDxDataGrid.forEach(col=> {
     
      i++;
      if(col.template){ // non usata
        let cpyCol=_this.nicaGridService.getTemplate(col.template)
        this.dataGridConfig.colonneDxDataGrid[i] = Object.assign(_this.dataGridConfig.colonneDxDataGrid[i], cpyCol);
        //this.dataGridConfig.colonne[i]={...cpyCol}        
        col=Object.assign(col,cpyCol)       
      }
      if(col.defaultValue){
        _this.costantByField[col.dataField]=col.defaultValue;
      }
      _this.columnByField[col.dataField]=col;
      
      _this.editorOptions[col.dataField]=col.editorOptions;      
      if(col.dataField)  _this.editorOptions[col.dataField]['inputAttr']['NicaGridComponent']=_this;      
      //let rt=_this.generateEditorOption(col);

      // forse va aggiunta _this.editorOptions[col.dataField]= _this.generateEditorOption(col);
     

      if(col.dataField)  _this.editorOptions[col.dataField]['inputAttr']['NicaGridComponent']=_this;      

      _this.relatedColumn[col.dataField]=col.relatedField;

      
      if(col.type=='campo' || col.type=='dxSelectBox'){
        if(col.relatedField){
          _this.relatedColumn[col.dataField]=col.relatedField;
        }
        if(col.dxolookup){
          let api=col.dxolookup.api;
          let filter='';
          if(_this.isNotEmpty(col.dxolookup.filter))  filter=col.dxolookup.filter;
          _this.dataSourceColonne[col.dataField]=_this.nicaGridService.CreateDsCustom(api,filter,col.dxolookup.valueExpr)
          if(col.dxolookup.cascating){
            _this.cascatingColumn[col.dataField]=col.dxolookup.cascating
          }
        }
      }
      _this.editorOptions[col.dataField]= _this.generateEditorOption(col);
      if(col.itemType=='button') _this.itemOptions[col.dataField]=_this.generateButton(col)
      if(col.itemType=='buttonGroup') _this.itemOptions[col.dataField]=_this.generateButtonGroup(col)
      if(col.itemType=='buttonGroup') _this.buttonOptions[col.dataField]=_this.generateButton(col)

      console.log("Ecco Editor Options di "+col.dataField,_this.editorOptions[col.dataField])
    })



  }
  private isNotEmpty(value: any): boolean {
    return value !== undefined && value !== null && value !== '';
  }
  tabPanel_tabTitleClick(e){
    alert("Premuto su title")
    console.log(e)
  }
  onContentReadygridMaster(e) {
    //var dataGridOptions = dataGridInstance.option();
    //console.log("Tutte le opzioni ",e.component.option());
    //e.component.option('loadPanel.enabled', false);
    //console.log(eval("findmasterThis()"))
    this.currentComponent=e;
  }
  private ValorizzaFunction(value,data){

  }
  onRowPrepared(e){
    // viene richiamata ogni variazione di nella form edit e per tutte le righe visibili
    //console.log("Preparato Row onRowPrepared",e)    
      console.log("Riga onRowPrepared",e.rowIndex);
  }
  onEditingStart(e){
    
    this.isNewRow=false;
    let currentEdit=-1
    let xx=this.gridMaster.instance.getVisibleRows()
    this.CurrentRowIndexEdit= e.component.getRowIndexByKey(e.key)

    const row = xx[this.CurrentRowIndexEdit];
    this.recordData =  row.data ;

    
    

    console.log("ecco le righe ",currentEdit)
    console.log("Preparato Editor onEditingStart",e)
  }
  onEditorPrepared(e){
    // viene eseguito per ogni riga ['isSetting']
    //console.log("Preparato Editor onEditorPrepared",e.dataField)
    if (e.parentType === "dataRow" && e.row.isNewRow ) {
      if(!this.columnByField[e.dataField]['isSetting'] && this.columnByField[e.dataField].type === "campo"){
        this.columnByField[e.dataField]['isSetting']=true;
        if(this.columnByField[e.dataField]['defaultValue']){
          this.columnByField[e.dataField]['currentValue']=this.columnByField[e.dataField]['defaultValue']
          e.setValue(this.columnByField[e.dataField]['defaultValue']);          
        }
        
      }

    }
  }
  onContentReadyButtonGroup(e){

    return; // viene chiamata per ogni riga e questo non va bene
    console.log("onContentReady" ,e)
    const data = e.component.option('elementAttr');
    console.log("onContentReady data",data)
    let myThis = data.NicaGridComponent;
    let name=data.name;
    let indexButton=-1;//data.indexButton;
    
    console.log("recordNewData ",myThis.recordNewData)
    console.log("recordData ",myThis.recordData)
    if(this.columnByField[name].onFlyEditorOptions){
      this.columnByField[name].onFlyEditorOptions.forEach(t=>{
        let key=t.key;let value=t.value;
        indexButton=t.indexButton;
        //------------------------------------------
        let command=value.split('=>');
        if(command.length>1){
          let field:_cascateLookUp={
            api:null,
            dataField:name,
            filter:command[1]
          }          
          let dynamicFunction=this.recalcFilter(field,'', myThis.recordData,myThis.recordNewData)
          let fn=eval("("+dynamicFunction+")")
          let ValueCalcolato=fn();
          let arrKey=key.split('.');
          if(arrKey.length>1){ // sono options
            if(arrKey[0]=='option' && indexButton){
              var items = e.component.option('items');
              items[indexButton][arrKey[1]] = ValueCalcolato;
              e.component.option('items', items);
            }
          }
        }
       
        //-------------------------------------------
        
      })
    }
  }
  //buttonGroup','disabled',0,true
  settaEditorOptionsGroupButton(name,option,index,value){
    console.log("Ecco il componente ");
    console.log(this.componentInstance[name]);
    let e=this.componentInstance[name];
    const data = e.option('elementAttr');
    console.log("onContentReady data",data)
    console.log("FINE Ecco il componente ");
    if(index>-1){
      var items = e.option('items');
      items[index][option] = value;
      e.option('items', items);  
    }
  }
  buttonGroupClick(e) {        
    console.log(e);
    //console.log(this.componentInstance)
    const data = e.component.option('elementAttr');
    console.log("data",data)
    let myThis = data.NicaGridComponent;
    alert("Clikkato in buttonGroupClick OK riga="+myThis.CurrentRowIndexEdit);   
    let name=data.name;
    /*
    var items = e.component.option('items');
    items[1].disabled = true;
    e.component.option('items', items);
    console.log(items);    
    */
  }
  generateButtonGroup(campo:_colonne) {
    let tt= [
      {
        icon: 'alignleft',
        alignment: 'left',        
        hint: 'Left',
        
        onClick: () => {
        //  console.log('Button 1 clicked');
        }
      },
      {
        icon: 'aligncenter',
        alignment: 'center',
        hint: 'Center',
        onClick: () => {
          //console.log('Button 2 clicked');
        }
      },
      {
        icon: 'alignright',
        alignment: 'right',
        hint: 'Right',
        onClick: () => {
          //console.log('Button 3 clicked');
        }
      },
      {
        icon: 'alignjustify',
        alignment: 'justify',
        hint: 'Justify',
        onClick: () => {
          //console.log('Button 4 clicked');
        }
      },
    ];
    console.log("OPTION GROUP ",tt);
    return tt;
  }
  generateButtonGroupOptions(campo:_colonne){
  }
  generateEditorOption(campo:_colonne){
    console.log("Ecco editor ",campo)

    
    if(campo.editorType=='dxSelectBox'){
      campo.editorOptions.dataSource=this.dataSourceColonne[campo.dataField];
      campo.editorOptions.displayExpr=campo.dxolookup.displayExpr;
      campo.editorOptions.valueExpr=campo.dxolookup.valueExpr;
      return campo.editorOptions
    }

    if(campo.editorType=='dxTextBox'){
      if(campo.optionalButton){       

        this.itemOptions[campo.dataField]=this.generateButton(campo)

        //campo.editorOptions.inputAttr.NicaGridComponent=this;        
        campo.editorOptions.buttons=[{
          name:'cercaNo',
          hint:'eccolooooooooooo',
          location:'after',
          options:{
            stylingMode: 'text',
            icon:'user',   
            elementAttr:{dataField:campo.dataField, id:"cerca",NicaGridComponent:this,optionalButton:campo.optionalButton},   
            disabled:false,      
          onClick: ($event) => {
            console.log("$event A",$event)
            const data = $event.component.option('elementAttr');
            console.log("data",data)
            console.log(this);
            let myThis=data.NicaGridComponent
            //let myThis = data.editorOptions.inputAttr.NicaGridComponent;
            console.log(myThis.columnByField[data.dataField])

            data.optionalButton.forEach((buttonOption :any)=>{
              buttonOption.eventi.forEach((evento :_Eventi)=>{
              if(evento.event=='onClick'){
                  if(evento.ExecuteRoutine>''){
                    let fn=eval("("+evento.ExecuteRoutine+")")
                    if(!myThis.newData) myThis.newData={...myThis.formData} 
                    let risposta=fn(data.dataField,'',myThis.newData,'',myThis.currentRowData,myThis,myThis.allParameterInput);
                    myThis.parsingResultRoutine(risposta,'',myThis,myThis.newData)                
                  }
              }
            })
            })
            $event.event.stopPropagation()





          }
          }
        }]
        return campo.editorOptions
      }else{
        //campo.editorOptions.inputAttr.NicaGridComponent=this;
        return campo.editorOptions
      }
  
    }else{
      //campo.editorOptions.inputAttr.NicaGridComponent=this;
        return campo.editorOptions
    }
    
    //optionalButton:[{name:'',hint:'Cerca Descrizione',icon:'user',location:'after'}],
    /*
name:string;
  icon?:string;
  text?:string;
  type?:string;
  hint?:any;
  location?:string;
  disabled?:boolean;
  focusStateEnabled?:boolean;
    */
//[{name:'cerca',location: 'after',options:{icon:'user'}}]
    if(campo.optionalButton){
      campo.editorOptions.buttons=[{
        name:'cerca',
        hint:'eccolooooooooooo',
        location:'after',
        option:{icon:'user',
        onClick: ($event) => {
          console.log("$event A",$event)
          const data = $event.component.option('elementAttr');
          console.log("data",data)
          let myThis = data.editorOptions.inputAttr.NicaGridComponent;
          console.log(myThis.columnByField[data.dataField])
        }
        }
      }]
      
    }else
    return campo.editorOptions;
  }
  generateButton(campo:_colonne) {
    
    return {
      text: campo.optionalButton[0].text,
      name: campo.optionalButton[0].name,
      elementAttr: campo,
      icon: campo.optionalButton[0].icon,
      type:campo.optionalButton[0].type,
      //stylingMode: campo.button.type,
      //hint: campo.button.hint,
      disabled: campo.optionalButton[0].disabled,
      //visible: campo.button.visible || campo.visible,
      onClick: ($event) => {
        console.log("$event A",$event)
        const data = $event.component.option('elementAttr');
        console.log("data",data)
        let myThis = data.editorOptions.inputAttr.NicaGridComponent;
        console.log(myThis.columnByField[data.dataField])
        let xx;
        let row
        let newData
        let dataField=data.dataField;
        let currentRowData={}
        if(!myThis.showGridForm){
          xx=myThis.gridMaster.instance.getVisibleRows()
          //this.masterCurrentEdit= $event.component.getRowIndexByKey(e.key)
          row = xx[myThis.CurrentRowIndexEdit];
          myThis.recordNewData =  row.data ;
          myThis.recordData=row.oldData;
          let newData=row.data;let currentvalue='';currentRowData=row.oldData;
        }else{
          myThis.recordNewData =  myThis.formData ;
          myThis.recordData=myThis.formData;
          //row.oldData=this.formData;
          currentRowData=myThis.formData;
          let dataField=data.dataField;let newData=myThis.formData;let currentvalue='';currentRowData=myThis.formData;
        }
        //emit optional button to parent component
        
        data.eventi.forEach((evento :_Eventi)=>{
          if(evento.event=='onClick'){
              if(evento.ExecuteRoutine>''){
                let fn=eval("("+evento.ExecuteRoutine+")")
                let risposta=fn(dataField,'',newData,'',currentRowData,myThis,myThis.allParameterInput);
                myThis.parsingResultRoutine(risposta,'',myThis,newData)                
              }
          }
        })
        $event.event.stopPropagation()
      }
    }
  }

  OptionalButtonClick(e){
    console.log("Ho clikkato sul pulsante ",e)
    //console.log("xxxx ",e.column.buttons[0].name)
  }

  onEditorPreparing(e){
    //console.log("onEditorPreparing ",e)
    if(e.parentType=='dataRow')
    {
      console.log("onEditorPreparing ",e.dataField)
      /* qua potrei modificare i campi 
      /*
        e.editorOptions.onValueChanged = function () {  
                    e.component.cellValue(e.row.rowIndex, "FirstName", "AnotherID");  
        }  
        oppure
        $('#myButton').dxButton({  
    onClick: function(){  
        store.update(1, { City: 'State42' });  
        grid.refresh();  
    },  
    text: 'code-edit'  
});  
oppure
$(e.editorElement).dxTextBox("instance").on("valueChanged", function (args) {  
                           var grid = $("#gridContainer").dxDataGrid("instance");  
                           var index = e.row.rowIndex;  
                           var result = "new description " + args.value;  
                           grid.cellValue(index, "description", result);  
                       });  
      
oppure 
setCellValue: function (rowData, value) {  
                      rowData.description = value;  
                      rowData.name = "new name " + value;  
}  


      */
      /*
      if(this.columnByField[e.dataField].dxolookup && this.columnByField[e.dataField].dxolookup.cascating){
          console.log("Ecco un DxSlectBox con cascating ",e)   
          let currentData=e.row.data;
          let currentValue=e.value;
          if(this.cascatingColumn[e.dataField]){
            let cascadeField=this.cascatingColumn[e.dataField]['dataField']
            let value=(e.row.data[e.dataField] == undefined) ? "":e.row.data[e.dataField]
            //this.refreshDSLookUpRelated(this.cascatingColumn[e.dataField],value, e.row.data,e.row.data)
          }
      }
*/
      if(this.columnByField[e.dataField].onFlyEditorOptions){
        this.columnByField[e.dataField].onFlyEditorOptions.forEach(t=>{
          let key=t.key;let value=t.value;
          let command=value.split('=>');
          if(command.length>1){
            let currentData=e.row.data;
            let currentValue=e.value;
            let field:_cascateLookUp={
              api:null,
              dataField:e.dataField,
              filter:command[1]
            }          
            let dynamicFunction=this.recalcFilter(field,currentValue, currentData,currentData)
            let fn=eval("("+dynamicFunction+")")
            let arrKey=key.split(',');
            arrKey.forEach(x=>{
              e.editorOptions[x]=fn();
            })
          }else{

          }
        })               
      }

    }
    //e.readOnly=true;
  }
  campoValueChangeRadio(this: Column,newData, value, currentRowData){
      alert('Cambiato Radio');
  }
  calculateCellValue(e: Column,){
    console.log("Calculate cell ",e)
  }
  campoValueChange(this: Column,newData, value, currentRowData){
    console.log("Cambiato valore  ",this)
    
    newData[this.dataField]=value;
    //let myThis = eval("findthisGrid()");
    let myThis = this.editorOptions.inputAttr.NicaGridComponent;
    myThis.columnByField[this.dataField]['currentValue']=value

  }
  
  onFormSubmit(e?) {

  }
  // eventi della FORM
  onValueChangedSelect(e:any,dataField:any){
    
    console.log("ecco onFormChanged ",e) 
    console.log('I dati della Form ',this.formData) 
    console.log('ecco this ',this) 
    //this.editorOptions.inputAttr.NicaGridComponent
    //this.columnByField[e.dataField].editorOptions.inputAttr.NicaGridComponent=this
    //this.elaboraDxiColumn(colonna,newData,value,currentRowData,myThis){
    this.elaboraDxiColumn(this.columnByField[dataField], this.formData,e.value,this.formData,this)
   //this.elaboraDxiColumn()

  }
  onFieldDataChanged(e: any) {
    //e.component;e.dataField;e.value;e.element
    console.log("ecco onFormChanged ",e)
    console.log('I dati della Form ',this.formData)  

    let dataField=e.dataField;
    let fieldDestination='';
    console.log("ecvco this ",this)
    //let myThis = eval("findthisGrid()");
    let myThis = this;//.editorOptions.inputAttr.NicaGridComponent;
    //newData[this.dataField]=e.value;
    //let localnewData=newData;
    //let ciccio=myThis.name_items.toArray();
    myThis.columnByField[dataField]['currentValue']=e.value
    this.recordNewData=this.formData



    this.elaboraDxiColumn(this.columnByField[e.dataField], this.formData,e.value,this.formData,this) 
    //this.setDxiColumn(this.columnByField[e.dataField], this.formData,e.value,this)

  }

//--------------------------------------------------------------------------------
  elaboraDxiColumn(colonna,newData,value,currentRowData,myThis){
    let dataField=colonna.dataField;
    let fieldDestination='';
    let localnewData=newData;

    console.log("colonna ",colonna);
    console.log("newData ",newData);
    console.log("value ",value);
    console.log("currentRowData ",currentRowData);  
    
    if(myThis.cascatingColumn[colonna.dataField]){
      let cascadeField=myThis.cascatingColumn[colonna.dataField]['dataField']
        newData[cascadeField]=null;
        myThis.refreshDSLookUpRelated(myThis.cascatingColumn[colonna.dataField],value, currentRowData,newData)        
    }
    if(myThis.relatedColumn[colonna.dataField] && myThis.relatedColumn[colonna.dataField].length>0){
      //Inizio Related
      myThis.relatedColumn[colonna.dataField].forEach(element=>{ 

        if(myThis.isNotEmpty(element['api']) && element['api']=='apiweb')
        { // vado per getbyid su ??
          //let apiS=element['api'].split("|");
          //if(!apiS || apiS.length<2) return; // parametri errati
          let currentData=currentRowData;
          let currentValue=value;
          let field:_cascateLookUp={
            api:null,
            dataField:dataField,
            filter:element['queryString']
          }                    
          let dynamicFunction=myThis.recalcFilter(field,currentValue, currentData,currentData)
          let ciccio=this;
          let element2=element;
          let currentEdit=-1;
          //alert("wwwwwwwwwwwww 1")
          myThis.appService.GetApi(dynamicFunction).then(result=>{
            //alert("wwwwwwwwwwwww 2")
            if(element.ExecuteRoutine){
              dynamicFunction=element.ExecuteRoutine;//  "function(field,externalData,newData,value,currentRowData,parent,allParameterInput){let tipo='success';let result=externalData.descrizione;if(externalData.pericoloso==true) {tipo='danger';result=externalData.descrizione+' *';}return {desCodicillo:{value:result},button2:{editorOption:{disabled:externalData.pericoloso,type:tipo}},message:'Ritorno dal futuro'};}"
              let fn=eval("("+dynamicFunction+")")
              let risposta=fn(dataField,result,newData,currentValue,currentRowData,myThis,myThis.allParameterInput);            
              myThis.parsingResultRoutine(risposta,'',myThis,newData)  
            }
          }, function(error) {
            //FAILURE
            if(element.onError){
              dynamicFunction=element.onError;
              let fn
              if(dynamicFunction.split('function').length==1)
                fn=eval("(function(field,externalData,newData,value,currentRowData,parent,allParameterInput)"+dynamicFunction+")")
              else
                fn=eval("("+dynamicFunction+")")
              
              //newData[colonna.dataField]=''
              let result=""
              let risposta=fn(dataField,result,newData,currentValue,currentRowData,myThis,myThis.allParameterInput);
              myThis.parsingResultRoutine(risposta,'',myThis,newData)  
            }
            //myThis.parsingResultRoutine(risposta,'',myThis,newData) 
            console.log(error);
        })
        }else
        if(element.ExecuteRoutine){ 
          // executeRoutine
          let currentValue=value;
          let row;
          if(!myThis.showGridForm){
            let xx=myThis.gridMaster.instance.getVisibleRows()
            row = xx[myThis.CurrentRowIndexEdit];
          }else{
            row={data:myThis.formData,oldData:myThis.formData}
          }
            myThis.recordNewData =  row.data ;
            myThis.recordData=row.oldData;
            let dataField=element.dataField;let newData=row.data;let currentvalue='';let currentRowData=row.oldData;
            let fn=eval("("+element.ExecuteRoutine+")")
            let risposta=fn(dataField,'',newData,value,currentRowData,myThis,myThis.allParameterInput);
          setTimeout(() => {
            myThis.parsingResultRoutine(risposta,'',myThis,newData)
          }, 100);
          return;               
        }
        
        if(element['api']=='CurrentData'){
          element.dataField.forEach(t=>{
            fieldDestination=t['fieldDestination'];
            let option='';
            let rr=t['fieldDestination'].split("."); //quaaaaaaaaaaa
            if(rr.length>1){
              //t['fieldDestination']=rr[0];
              fieldDestination=rr[0]
              option=rr[1]
            }
            
            if(element.executeFunc){
              /*
                api:'CurrentData',
                dataField:[{fieldDatasource:'regione',fieldDestination:'testoAggiuntivoRegionale'},], 
                executeFunc:"function(){if('{{regione}}'=='E') return 'hai selezionato la regione E'; else return 'Hai sbagliato Regione';}"
              */
              let currentData=currentRowData;
              let currentValue=value;
              let field:_cascateLookUp={
                api:null,
                dataField:dataField,
                filter:element.executeFunc
              }          
              let dynamicFunction=myThis.recalcFilter(field,currentValue, currentData,currentData)
              let fn=eval("("+dynamicFunction+")")
              let result=fn();
              if(option>''){
                //myThis.itemOptions[t['fieldDestination']][option]=result;
                myThis.itemOptions[fieldDestination][option]=result;
              }else
                newData[fieldDestination]=result;
          //let arrKey=key.split(',');
          //arrKey.forEach(x=>{
            //e.editorOptions[x]=fn();
          //})
            }else{
                        
              localnewData[t['fieldDestination']]=myThis.columnByField[t['fieldDatasource']]['currentValue']
            }
            myThis.columnByField[fieldDestination]['currentValue']=value
          })
        }
        else
        if(element['api']=='CurrentDs' &&
        myThis.dataSourceColonne[colonna.dataField]){
          let data =  myThis.dataSourceColonne[colonna.dataField]['__rawData'].find(t=>t[element['key']] ===value);
          if(data){
            element.dataField.forEach(t=>{
              newData[t['fieldDestination']]=data[t['fieldDatasource']]
              
            })
          } // myThis.columnByField[this.dataField]['currentValue']
            console.log("trovato ",data)
        }         
        
      })
      //fine Related
     /*else if(typeof (<any>this).setCellValue === "function")
        (<any>this).setCellValue(newData, value, currentRowData)*/
  
        /*
        this: Column, newData: any, value: any, currentRowData: any
 relatedField:{
          // get byID
          api:'CurrentDs',  // CurrentDs se lista ,CurrentData form o nome  apiweb
          dataField:[{fieldDatasource:'elencoProvincie',fieldDestination:'elencoProvincie'}],          
          valore:'value',
          key:'id'  // si riferisce alla key del datasource corrente da comparere con value
        },
        */
    }
    



  }

  setDxiColumn(this: Column, newData: any, value: any, currentRowData: any,pippo?:any){        
/*
    if(typeof (<any>this).defaultSetCellValue === "function") { 
      (<any>this).defaultSetCellValue(newData, value, currentRowData);
    }
  */  
    let dataField=this.dataField;
    let fieldDestination='';
    console.log("ecvco this ",this)
    //let myThis = eval("findthisGrid()");
    let myThis = this.editorOptions.inputAttr.NicaGridComponent;
    newData[this.dataField]=value;
    let localnewData=newData;
    //let ciccio=myThis.name_items.toArray();
    myThis.columnByField[this.dataField]['currentValue']=value
    if(!currentRowData) myThis.recordNewData=newData;else
    myThis.recordNewData=currentRowData;
 
   myThis.elaboraDxiColumn(this,newData,value,currentRowData,myThis);
   return;

    if(myThis.cascatingColumn[this.dataField]){
      let cascadeField=myThis.cascatingColumn[this.dataField]['dataField']
        newData[cascadeField]=null;
        myThis.refreshDSLookUpRelated(myThis.cascatingColumn[this.dataField],value, currentRowData,newData)
    }
    if(myThis.relatedColumn[this.dataField] && myThis.relatedColumn[this.dataField].length>0){
      //Inizio Related
      myThis.relatedColumn[this.dataField].forEach(element=>{ 

        if(myThis.isNotEmpty(element['api']) && element['api']=='apiweb')
        { // vado per getbyid su ??
          //let apiS=element['api'].split("|");
          //if(!apiS || apiS.length<2) return; // parametri errati
          let currentData=currentRowData;
          let currentValue=value;
          let field:_cascateLookUp={
            api:null,
            dataField:dataField,
            filter:element['queryString']
          }                    
          let dynamicFunction=myThis.recalcFilter(field,currentValue, currentData,currentData)
          let ciccio=this;
          let element2=element;
          let currentEdit=-1;
          myThis.appService.GetApi(dynamicFunction).then(result=>{
            if(element.ExecuteRoutine){
              dynamicFunction=element.ExecuteRoutine;//  "function(field,externalData,newData,value,currentRowData,parent,allParameterInput){let tipo='success';let result=externalData.descrizione;if(externalData.pericoloso==true) {tipo='danger';result=externalData.descrizione+' *';}return {desCodicillo:{value:result},button2:{editorOption:{disabled:externalData.pericoloso,type:tipo}},message:'Ritorno dal futuro'};}"
              let fn=eval("("+dynamicFunction+")")
              let risposta=fn(dataField,result,newData,currentValue,currentRowData,myThis,myThis.allParameterInput);            
              myThis.parsingResultRoutine(risposta,'',myThis,newData)  
            }
          })
        }else
        if(element.ExecuteRoutine){ 
          // executeRoutine
          let currentValue=value;
          let xx=myThis.gridMaster.instance.getVisibleRows()
          const row = xx[myThis.CurrentRowIndexEdit];
          myThis.recordNewData =  row.data ;
          myThis.recordData=row.oldData;
          let dataField=element.dataField;let newData=row.data;let currentvalue='';let currentRowData=row.oldData;
          let fn=eval("("+element.ExecuteRoutine+")")
          let risposta=fn(dataField,'',newData,value,currentRowData,myThis,myThis.allParameterInput);
          setTimeout(() => {
            myThis.parsingResultRoutine(risposta,'',myThis,newData)
          }, 100);
          return;               
        }
        
        if(element['api']=='CurrentData'){
          element.dataField.forEach(t=>{
            fieldDestination=t['fieldDestination'];
            let option='';
            let rr=t['fieldDestination'].split("."); //quaaaaaaaaaaa
            if(rr.length>1){
              //t['fieldDestination']=rr[0];
              fieldDestination=rr[0]
              option=rr[1]
            }
            
            if(element.executeFunc){
              /*
                api:'CurrentData',
                dataField:[{fieldDatasource:'regione',fieldDestination:'testoAggiuntivoRegionale'},], 
                executeFunc:"function(){if('{{regione}}'=='E') return 'hai selezionato la regione E'; else return 'Hai sbagliato Regione';}"
              */
              let currentData=currentRowData;
              let currentValue=value;
              let field:_cascateLookUp={
                api:null,
                dataField:dataField,
                filter:element.executeFunc
              }          
              let dynamicFunction=myThis.recalcFilter(field,currentValue, currentData,currentData)
              let fn=eval("("+dynamicFunction+")")
              let result=fn();
              if(option>''){
                //myThis.itemOptions[t['fieldDestination']][option]=result;
                myThis.itemOptions[fieldDestination][option]=result;
              }else
                newData[fieldDestination]=result;
          //let arrKey=key.split(',');
          //arrKey.forEach(x=>{
            //e.editorOptions[x]=fn();
          //})
            }else{
                        
              localnewData[t['fieldDestination']]=myThis.columnByField[t['fieldDatasource']]['currentValue']
            }
            myThis.columnByField[fieldDestination]['currentValue']=value
          })
        }
        else
        if(element['api']=='CurrentDs' &&
        myThis.dataSourceColonne[this.dataField]){
          let data =  myThis.dataSourceColonne[this.dataField]['__rawData'].find(t=>t[element['key']] ===value);
          if(data){
            element.dataField.forEach(t=>{
              newData[t['fieldDestination']]=data[t['fieldDatasource']]
              
            })
          } // myThis.columnByField[this.dataField]['currentValue']
            console.log("trovato ",data)
        }         
        
      })
      //fine Related
      if(typeof (<any>this).defaultSetCellValue === "function") { 
        (<any>this).defaultSetCellValue(newData, value, currentRowData);
      }/*else if(typeof (<any>this).setCellValue === "function")
        (<any>this).setCellValue(newData, value, currentRowData)*/
  
        /*
        this: Column, newData: any, value: any, currentRowData: any
 relatedField:{
          // get byID
          api:'CurrentDs',  // CurrentDs se lista ,CurrentData form o nome  apiweb
          dataField:[{fieldDatasource:'elencoProvincie',fieldDestination:'elencoProvincie'}],          
          valore:'value',
          key:'id'  // si riferisce alla key del datasource corrente da comparere con value
        },
        */
    }
    
    if(typeof (<any>this).defaultSetCellValue === "function") { 
      (<any>this).defaultSetCellValue(newData, value, currentRowData);
    }
   
  }
  
  //---------------------  FUNZIONI PUBLIC ----------------------------
  public refreshDS(){
    this.dataGridConfig.dataSource=this.nicaGridService.CreateDs(this.dataGridConfig.Api,this.dataGridConfig.QueryString,this.dataGridConfig.key);
  }
  
  public refreshDSLookUpRelated(field:_cascateLookUp,value:any, currentRowData:any,newData:any){    
    let dynamicFilter=this.recalcFilter(field,value, currentRowData,newData)
    let dynamicApi=this.recalcFilter({filter:field.api},value, currentRowData,newData)
    this.dataSourceColonne[field['dataField']]=null;

      this.dataSourceColonne[field['dataField']]=
      this.nicaGridService.CreateDsCustom(dynamicApi,dynamicFilter,'id');
      this.dataSourceColonne[field['dataField']].load({  $filter:dynamicFilter  });

  }
  private eseguiFunction(fn:string,value:any, currentRowData:any,newData:any){
    var variable = fn.match(/{{[\w\d]+}}/g);
    for(let r=0;r<variable.length;r++){
      let v=variable[r].replace('}}','');
      v=v.replace('{{','');
      if(v=='value'){
        fn=fn.replace(variable[r],value) 
      }else{
        //aggiungere il controllo su newData
        fn=fn.replace(variable[r],currentRowData[v]) 
      }
    }
    return fn;      
  }
  private parsingFunction(funtion,value, currentRowData,result){
    let filter=funtion; 
    var variable = filter.match(/{{[\w\d]+}}/g);
    for(let r=0;r<variable.length;r++){
      let v=variable[r].replace('}}','');
      v=v.replace('{{','');
      if(v=='value'){
        let newValue=value;        
       filter=filter.replace(variable[r],newValue) 
      }else{
        //aggiungere il controllo su newData
        let newValue=currentRowData[v];
        filter=filter.replace(variable[r],newValue) 
      }
    }
    return filter;  
  }
  RecordUpdate(e){
    
  }
  private parsingResultRoutine(value,parentNodo,myThis,newData){
    let nodo,chiave,currentValue   
    Object.keys(value).forEach(function(key) {   
      if (typeof value[key] == 'object'){  
        let padre='';
        if(parentNodo>'') padre=parentNodo+"."+key; else padre=key 
        myThis.parsingResultRoutine(value[key],padre,myThis,newData)        
      }
      else{
            console.log("VALUEEEEEE ",key,value[key],parentNodo);    
            let rr=parentNodo.split(".");
            if(rr.length==1 && rr[0]>""){
              newData[rr[0]]=value[key] 
              myThis.columnByField[rr[0]]['currentValue']=value[key] 
              if(!myThis.showGridForm)                         
                myThis.updateCell(myThis.CurrentRowIndexEdit,rr[0],value[key]);
              else
              {
                myThis.formMaster.instance.updateData(parentNodo, value[key])
                myThis.columnByField[parentNodo]['currentValue']=value[key]                           
              }
            }else if(rr[1]=='editorOption'){              
              myThis.itemOptions[rr[0]][key]=value[key];
              //console.log(myThis.dataSourceColonne['regione'])
              //myThis.formMaster.instance.updateData('regione', 'F')
              //myThis.formMaster.instance.updateData('button1', 'F')
              if(!myThis.showGridForm)                         
                myThis.updateCell(myThis.CurrentRowIndexEdit,rr[0],value[key]); 
              //else 
              //  myThis.columnByField[parentNodo]['currentValue']=value[key]
            }
      } 
  });            
  }


  private recalcFilter(field:_cascateLookUp,value:any, currentRowData:any,newData:any){
      let filter=field.filter; 
      var variable = filter.match(/{{[\w\d\W]+}}/g);
      if (!variable) return filter;
      for(let r=0;r<variable.length;r++){
        let v=variable[r].replace('}}','');
        v=v.replace('{{','');
        if(v=='value'){
          let newValue=value;
          if(Array.isArray(value)) newValue='['+value.join(",")+']'
         filter=filter.replace(variable[r],newValue) 
        } if(v.includes('$this')){
          let arrV=v.split(".");
          let newValue=this[arrV[1]];
          filter=filter.replace(variable[r],newValue+'') 
        }else{
          //aggiungere il controllo su newData
          let newValue
          if(newData[v])
            newValue=newData[v];
          else newValue=currentRowData[v];
            
          if(Array.isArray(currentRowData[v])) 
            newValue='['+currentRowData[v].join(",")+']'

          filter=filter.replace(variable[r],newValue) 
        }
      }
      return filter;      
  }
  // setta filtri data e ricarica la griglia
  //es. query=?filter=siglaprovincia eq 'NA' ecc.ecc.
  public setFilter(query){
    this.dataGridConfig.QueryString=query;
    this.refreshDS();    
  }
  dammicolspan(item){
    return  parseInt(item.colSpan);
  }
  vedichenenescefuori($event){
    const data = $event.component.option('elementAttr');
    console.log("data",data)
    let myThis = data.editorOptions.inputAttr.NicaGridComponent;
    console.log('Button 1 clickedddd');
  
  }
  NewRecord(e){
    //this.costantByField.[col.dataField]
    
    this.isNewRow=true;
    this.recordNewData={}
    this.recordData={}
    console.log("New Record ",this.columnByField  )
    let myThis=this;
    Object.keys(this.columnByField).forEach(function(key) {
      myThis.columnByField[key]['isSetting']=false;
      myThis.columnByField[key]['currentValue']=null;
      console.log("New Record element",myThis.columnByField[key])
    })
    return;
    
    this.columnByField.foreach(elem=>{
     
    })
      
    return;
    this.isNewRow=true;
    let _this=this;
    console.log("On New Record e ",e)
    Object.keys(_this.costantByField).forEach(function(key) {
      //alert("Nuovo "+_this.costantByField[key])
      
      /*let xx=_this.gridMaster.instance.getVisibleRows()
      _this.CurrentRowIndexEdit= e.component.getRowIndexByKey(e.key) 
      const row = xx[_this.CurrentRowIndexEdit];
      this.recordData =  row.data ;*/
      e.data[key]=_this.costantByField[key]
      //_this.updateCell(_this.CurrentRowIndexEdit, key, _this.costantByField[key])
  
    })   
    this.recordData=e.data;
    setTimeout(() => {
      //ddd 
      //this.updateCell(0, 'regione', 'P')
      //this.gridMaster.instance.refresh();
      //this.gridMaster.instance.addRow();
      //alert("Aggiuntooooooooooooooooo")
      this.refreshDSLookUpRelated(this.cascatingColumn['regione'],'P', this.recordData,this.recordData)

    }, 400);

  }

  
  saveInstance (e,field) {
    console.log("instance ",field)
    this.componentInstance[field] = e.component;

}
  startInizialed(e){
    console.log("Inizializzazione Tab ",e)
  }
  // setta le opzioni della griglia
  public setOptionsGriglia(option:string,value:string){
    // alert("www")
    // //e.component.option('loadPanel.enabled', false);
    this.currentComponent.component.option(option, value);
    //this.refreshDS();    
  }

}
export { _colonne };

